import { InjectionToken } from '@angular/core';

export interface DalOptions {
  apiBaseUrl: string;
}

export const DAL_OPTIONS = new InjectionToken<DalOptions>('dal-options');
